import LlmTable from "/src/features/ai/llm/components/LlmTable/LlmTable";

function LlmList() {

    return <LlmTable/>
}

export default LlmList;